import React from 'react';
import { RotatePhone } from '../RotatePhone';
import { Desktop, Landscape, Mobile, Portrait } from '../../utils/breakpoint';
import { Div } from '@kizi/core-components';

export interface ExperienceManagerProps {
  label: string;
}

export const ExperienceManager: React.FC<ExperienceManagerProps> = ({
  label,
  children,
}) => {
  return (
    <>
      <Desktop>
        <Div>{children}</Div>
      </Desktop>
      <Mobile>
        <Portrait>
          <Div variant="mobileExpContainer">
            <Div display="flex" alignItems="center" justifyContent="center">
              <RotatePhone label={label} />
            </Div>
          </Div>
        </Portrait>
        <Landscape>
          <Div>{children}</Div>
        </Landscape>
      </Mobile>
    </>
  );
};
